module.exports = __webpack_public_path__ + "img/105.4a496d91.png";